import React, { useState } from "react";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

 // ... (existing code)

 const handleLogin = async () => {
  setLoading(true);
  setError("");

  const apiUrl = "https://api.kalmesh.in/BabyStepsAPI/admin-login";

  const formData = new FormData();
  formData.append("email", email);
  formData.append("password", password);
  formData.append("trans_from", "ADMIN");

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      const responseData = await response.json();

      if (responseData.status === "success") {
        console.log("Login successful!");
        console.log("User data:", responseData.data);

        // Save the API token to session storage
        sessionStorage.setItem("api_token", responseData.data.api_token);

        // Redirect to the "/dashboard" page
        window.location.href = "/dashboard";
      } else {
        setError("Incorrect credentials");
      }
    } else {
      const errorData = await response.json().catch(() => null);
      setError(`Login failed: ${response.status} ${response.statusText}`);
      if (errorData) {
        console.error("Error response body:", errorData);
      }
    }
  } catch (error) {
    setError("Error: " + error.message);
    console.error("Error:", error);
  } finally {
    setLoading(false);
  }
};



  return (
    <div>
<meta charSet="utf-8" />
  <link rel="stylesheet" href="bootstrap.css" />
  <style
 dangerouslySetInnerHTML={{
  __html: `
    .global-container {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: url('img/baby-massage.jpg'); /* Add your image URL here */
      background-size: cover;
      background-position: center;
      color:black;
      font-weight:800px;
    }

    form {
      padding-top: 10px;
      font-size: 14px;
      margin-top: 30px;
      color:black;
      font-weight:800px;
      
    }

    .card-title {
      font-weight: 300;
      color:black;
      font-weight:800px;
    }

    .btn {
      font-size: 14px;
      margin-top: 20px;
    }

    .login-form {
      width: 330px;
      margin: 12.5%;
      background-color: rgba(255, 255, 255, 0.6); /* Set the last value (0.5) for transparency */
    }
    
    .alert {
      margin-bottom: -30px;
      font-size: 13px;
      margin-top: 20px;
    }
  `,
}}


/>


<div className="global-container">
  <div className="card login-form" style={{}}>
    <div className="card-body">
      <h3 className="card-title text-center">Log in to BabyCare</h3>
      <div className="card-text">
        {/*
			<div class="alert alert-danger alert-dismissible fade show" role="alert">Incorrect username or password.</div> */}
        <form>
          {/* to error: add class "has-danger" */}
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Email address</label>
            <input
             type="text"
              className="form-control form-control-sm"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"  
        placeholder="Enter Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="exampleInputPassword1">Password</label>
           
            <input
              type="password"
              className="form-control form-control-sm"
              id="exampleInputPassword1"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && <div className="error-message" style={{color:"red"}}>{error}</div>}
          <button type="submit" className="btn btn-primary btn-block"
           onClick={handleLogin}
           disabled={loading}>
           {loading ? "Logging in..." : "Login"}
          </button>
          
        </form>
      </div>
    </div>
  </div>
</div>
</div>


    
  );
};
